module.exports = __webpack_public_path__ + "img/dent.434607f1.svg";